import { Villa, VillaStatus, VillasResponse } from './types';

const envBase =
  (import.meta as { env?: { VITE_API_BASE?: string } }).env?.VITE_API_BASE;

const origin =
  typeof window !== 'undefined' ? window.location.origin : null;

// If мы на pages.dev (чистый фронт без прокси) — жёстко идём на туннель.
const pagesDefault =
  'https://apart-airline-tour-decisions.trycloudflare.com/api';

const apiBaseFromOrigin =
  origin && !origin.includes('pages.dev') ? `${origin}/api` : pagesDefault;

const API_BASE = (envBase || apiBaseFromOrigin || pagesDefault).replace(/\/$/, '');

export async function fetchVillas(): Promise<VillasResponse> {
  const res = await fetch(`${API_BASE}/villas`);
  if (!res.ok) throw new Error('Failed to fetch villas');
  return res.json();
}

export async function fetchArchived(): Promise<VillasResponse> {
  const res = await fetch(`${API_BASE}/villas/archived`);
  if (!res.ok) throw new Error('Failed to fetch archived');
  return res.json();
}

export async function fetchVilla(id: string): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}`);
  if (!res.ok) throw new Error('Failed to fetch villa');
  return res.json();
}

export async function updateVilla(
  id: string,
  data: Partial<{
    status: VillaStatus;
    pinned: boolean;
    phone: string | null;
    comment: string | null;
    price: number | null;
    district: string | null;
    image: string | null;
    images: string[] | null;
  }>
): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update villa');
  return res.json();
}

export async function togglePin(id: string, pinned: boolean): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}/pin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pinned }),
  });
  if (!res.ok) throw new Error('Failed to update pin');
  return res.json();
}

export async function deleteVilla(id: string): Promise<void> {
  const res = await fetch(`${API_BASE}/villas/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete villa');
}

export async function fetchVillaImages(id: string): Promise<{ images: string[]; count: number }> {
  const res = await fetch(`${API_BASE}/villas/${id}/fetch-images`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error('Failed to fetch images');
  return res.json();
}

// Normalize phone to +62 format
export function normalizePhone(phone: string): string {
  let cleaned = phone.replace(/\D/g, '');

  // Remove leading 0, add +62
  if (cleaned.startsWith('0')) {
    cleaned = '62' + cleaned.slice(1);
  } else if (!cleaned.startsWith('62')) {
    cleaned = '62' + cleaned;
  }

  return '+' + cleaned;
}

// Format phone for display
export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.startsWith('62') && cleaned.length > 10) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5, 9)} ${cleaned.slice(9)}`;
  }
  return '+' + cleaned;
}

// Create WhatsApp link
export function createWhatsAppLink(phone: string): string {
  const normalized = normalizePhone(phone);
  return `https://wa.me/${normalized.replace(/\+/g, '')}`;
}

// Extract domain for display
export function extractDomain(url: string): string {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace('www.', '');
  } catch {
    return url;
  }
}
